export default function CExamples() {
  return <h2>C Examples</h2>;
}
